"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var RichContent = /** @class */ (function (_super) {
    __extends(RichContent, _super);
    function RichContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RichContent.prototype.render = function () {
        var _a = this.props, data = _a.data, section = _a.section;
        var settings = section.settings, blocks = section.blocks;
        var article = data.template && data.template.name == "article";
        var foreground = settings && settings.foreground ? settings.foreground.toLowerCase() : article ? "charcoal" : "midnight";
        var background = settings && settings.background ? settings.background.toLowerCase() : article ? "transparent" : "arctic";
        var width = settings && settings.width ? settings.width.toLowerCase() : "";
        var alinment = settings && settings.textalignment ? settings.textalignment.toLowerCase() : "";
        var horizontal = settings && settings.contentalignment
            ? settings.contentalignment.toLowerCase().replace("left", "start").replace("right", "end")
            : "center";
        return settings && blocks ? (React.createElement("section", { className: "dynamic-richtext bg-" + background + " text-" + (foreground == "midnight" ? "navy-dark" : foreground) + (settings.verticalspacing ? " py-2-4 md:py-6-4" : "") + (article ? " my-2-4 md:my-6-4" : "") },
            React.createElement(Snippets.Container, { width: article ? "xs" : "xl", className: "" + (!article ? "mlg:px-11 md:px-2-4 px-1-6" : "") }, article ? (React.createElement(Snippets.RichText, { size: "mono", className: "mb-2-4 text-charcoal" }, settings.content)) : (React.createElement("div", { className: "flex flex-col md:flex-wrap md:flex-row md:-mx-0-9 justify-" + horizontal }, blocks
                .filter(function (item) {
                return item.settings.label ||
                    item.settings.title ||
                    item.settings.titletwo ||
                    item.settings.titlethree ||
                    item.settings.titlefour ||
                    item.settings.content;
            })
                .map(function (block, i) {
                var width = settings.width ? settings.width : "1/" + blocks.length;
                return (React.createElement("div", { key: i, className: "block md:px-0-9 w-full md:w-" + width + " text-" + alinment },
                    block.settings.label && (React.createElement(Snippets.Heading, { size: "h5", className: "mb-1-6 uppercase font-medium tracking-wide" }, block.settings.label)),
                    block.settings.title && (React.createElement(Snippets.Heading, { size: "h1", className: "mb-3-2 mt-1-6" }, block.settings.title)),
                    block.settings.titletwo && (React.createElement(Snippets.Heading, { size: "h2", className: "mb-2-4" }, block.settings.titletwo)),
                    block.settings.titlethree && (React.createElement(Snippets.Heading, { size: "h3", className: "mb-2-4 font-semibold" }, block.settings.titlethree)),
                    block.settings.titlefour && (React.createElement(Snippets.Heading, { size: "h4", className: "mb-1-6 font-semibold leading-tight" }, block.settings.titlefour)),
                    block.settings.content && (React.createElement(Snippets.RichText, { className: "mb-2-4" + (foreground === "midnight" ? " text-grey-dark" : null) }, block.settings.content))));
            })))))) : null;
    };
    RichContent.sectionId = "richtxt";
    return RichContent;
}(React.PureComponent));
exports.RichContent = RichContent;
